<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps<{
  id: string;
  label: string;
  type?: 'text' | 'email' | 'password';
  autocomplete?: string;
  placeholder?: string;
  invalid?: boolean;
  required?: boolean;
}>();

const model = defineModel<string>({ default: '' });
const revealed = ref(false);
</script>

<template>
  <div class="flex flex-col gap-[6px]">
    <div class="flex items-center justify-between px-2">
      <label
        :for="id"
        class="text-encre-douce text-[12px] leading-[14px] font-semibold"
      >
        {{ label }}
      </label>
      <button
        v-if="props.type === 'password'"
        type="button"
        class="text-encre flex h-5 w-5 cursor-pointer items-center justify-center rounded-full"
        :aria-label="
          revealed ? 'Masquer le mot de passe' : 'Afficher le mot de passe'
        "
        :aria-pressed="revealed"
        @click="revealed = !revealed"
      >
        <v-icon :name="revealed ? 'custom-eye-slash-2' : 'custom-eye-2'" />
      </button>
    </div>
    <input
      :id="id"
      v-model="model"
      :type="props.type === 'password' && revealed ? 'text' : props.type"
      :autocomplete="autocomplete"
      :placeholder="placeholder"
      :required="required"
      :aria-invalid="invalid"
      class="bg-carte text-encre placeholder:text-encre-douce h-12 w-full rounded-full px-5 text-[14px] leading-5 outline-none focus-visible:shadow-[inset_0_0_0_2px_var(--pds-encre)]"
    />
  </div>
</template>
